import { ButtonDropdownProps } from '@amzn/awsui-components-core/button-dropdown';
import { ProfileDropDownPanelLinks } from 'src/constants/AppConstants';

export interface AssistantConfig {
  id: string;
  name: string;
  description: string;
}

export const ASSISTANT_OPTIONS: Record<'askRino' | 'quickSuite', AssistantConfig> = {
  askRino: {
    id: 'ask-rino',
    name: 'Ask Rino',
    description: 'DaS Knowledge Assistant'
  },
  quickSuite: {
    id: 'quicksuite',
    name: 'Amazon Quick',
    description: "Amazon's AI Assistant"
  }
};

export const PROFILE_DROPDOWN_ITEMS: ReadonlyArray<ButtonDropdownProps.ItemOrGroup> = [
  {
    id: 'general',
    text: 'MY STUFF',
    items: [
      { id: 'profile', text: 'Profile', href: ProfileDropDownPanelLinks.PROFILE },
      { id: 'atoz', text: 'A to Z', href: ProfileDropDownPanelLinks.ATOZ },
      { id: 'timeoff', text: 'Request Time Off', href: ProfileDropDownPanelLinks.TIME_OFF },
      {
        id: 'badge-report',
        text: 'My Badge Report',
        href: ProfileDropDownPanelLinks.BADGE_REPORT
      },
      { id: 'ivy', text: 'Ivy', href: ProfileDropDownPanelLinks.IVY },
      { id: 'tasks', text: 'Tasks', href: ProfileDropDownPanelLinks.TASKS }
    ]
  },
  {
    id: 'workplace',
    text: 'WORKPLACE',
    items: [
      { id: 'phonetool', text: 'Phone Tool', href: ProfileDropDownPanelLinks.PHONE_TOOL },
      { id: 'bookroom', text: 'Book Room / Meeting', href: ProfileDropDownPanelLinks.BOOK_ROOM },
      { id: 'wiki', text: 'Wiki', href: ProfileDropDownPanelLinks.WIKI },
      { id: 'shout-outs', text: 'Shout Outs', href: ProfileDropDownPanelLinks.SHOUT_OUTS },
      { id: 'password', text: 'Password Unlock', href: ProfileDropDownPanelLinks.PASSWORD_UNLOCK }
    ]
  },
  {
    id: 'manage',
    text: 'MANAGER HUB',
    items: [
      { id: 'connections', text: 'Connections', href: ProfileDropDownPanelLinks.CONNECTIONS },
      { id: 'clarity', text: 'Clarity', href: ProfileDropDownPanelLinks.CLARITY },
      { id: 'roster', text: 'Roster', href: ProfileDropDownPanelLinks.ROSTER },
      { id: 'blue-print', text: 'Blueprint', href: ProfileDropDownPanelLinks.BLUEPRINT },
      { id: 'hire', text: 'Hire', href: ProfileDropDownPanelLinks.HIRE },
      { id: 'teams', text: 'Teams', href: ProfileDropDownPanelLinks.TEAMS },
      { id: 'email-lists', text: 'Email Lists', href: ProfileDropDownPanelLinks.EMAIL_LISTS }
    ]
  },
  {
    id: 'access',
    text: 'ACCESS',
    items: [
      { id: 'aws-access', text: 'AWS Account Access', href: ProfileDropDownPanelLinks.AWS_ACCOUNT_ACCESS },
      { id: 'tickets', text: 'Trouble Ticketing', href: ProfileDropDownPanelLinks.TROUBLE_TICKETING },
      { id: 'permissions', text: 'Permission Groups', href: ProfileDropDownPanelLinks.PERMISSION_GROUPS },
      { id: 'it-support', text: 'IT Support', href: ProfileDropDownPanelLinks.IT_SUPPORT },
      { id: 'it-marketplace', text: 'IT Marketplace', href: ProfileDropDownPanelLinks.IT_MARKETPLACE }
    ]
  },
  {
    id: 'travel',
    text: 'TRAVEL',
    items: [
      { id: 'book-travel', text: 'Book Travel', href: ProfileDropDownPanelLinks.BOOK_TRAVEL },
      { id: 'trail', text: 'Trail', href: ProfileDropDownPanelLinks.TRAIL },
      {
        id: 'travel-promos',
        text: 'Travel Promotions',
        href: ProfileDropDownPanelLinks.TRAVEL_PROMOTIONS
      },
      { id: 'expenses', text: 'Submit Expenses', href: ProfileDropDownPanelLinks.SUBMIT_EXPENSES },
      { id: 'move-in-sync', text: 'Move in Sync', href: ProfileDropDownPanelLinks.MOVE_IN_SYNC }
    ]
  },
  {
    id: 'people',
    text: 'GROWTH',
    items: [
      { id: 'learning', text: 'Learning Hub', href: ProfileDropDownPanelLinks.LEARNING_HUB },
      { id: 'job-finder', text: 'Job Finder', href: ProfileDropDownPanelLinks.JOB_FINDER },
      { id: 'helpful-links', text: 'Other Helpful Links', href: ProfileDropDownPanelLinks.OTHER_HELPFUL_LINKS }
    ]
  }
];
